import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-rests-tax-disc",
  "use": "icon-icon-rests-tax-disc-usage",
  "viewBox": "0 0 40 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 21\" id=\"icon-icon-rests-tax-disc\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#E6A23C\" width=\"40\" height=\"21\" rx=\"10.5\" /><text font-family=\"PingFangSC-Regular, PingFang SC\" font-size=\"12\" fill=\"#FFF\"><tspan x=\"8\" y=\"15\">分盘</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol